'use client'

import triggerAnalytics from '@gamezop/analytics-sdk/client/trigger-analytics'
import {useEffect} from 'react'
import {pageLoadComplete} from '@app/analytics/event-type'
import {
  TagsPageAnalyticsData,
  useTagsPageAnalytics,
} from '@app/[lang]/(common-header-footer)/tags/(tag-page)/[tagName]/[tagId]/get-tag-page-analytics/tag-page-analytics-context'
import {getClientAttributes} from '@app/analytics/utils/get-client-attributes'
import {getBrowserFeatures} from '@app/analytics/events/browser-features'
import {getDeviceCapabilities} from '@app/analytics/events/device-capabilities'
import {getNetworkInfo} from '@app/analytics/events/network-info'

type Props = {
  additionalAttributes?: Record<string, unknown>
}

const PageLoadCompleteEventClient = ({additionalAttributes}: Props) => {
  const {setTagAnalyticsData} = useTagsPageAnalytics()
  useEffect(() => {
    const trackAnalytics = async () => {
      const clientAttributes = getClientAttributes()

      // Get all analytics data
      const browserFeatures = getBrowserFeatures()
      const deviceCapabilities = await getDeviceCapabilities()
      const networkInfo = getNetworkInfo()

      // Combine all attributes for page load complete event
      const allAttributes = {
        ...clientAttributes,
        ...additionalAttributes,
        ...browserFeatures,
        ...deviceCapabilities,
        ...(networkInfo || {}),
      }

      // Send page load complete event with all data
      triggerAnalytics(pageLoadComplete, allAttributes).sendAll()
    }

    trackAnalytics()
    setTagAnalyticsData(additionalAttributes as TagsPageAnalyticsData)
  }, [])

  return null
}

export default PageLoadCompleteEventClient
